  <ng-container *ngFor="let term of allPaymentTerms">
    <p-fieldset legend="{{term.name}}" [toggleable]="true">
      <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" style="float: right;">
        <i class="pi pi-trash" (click)="checkDeleteStatus(term)"></i></span>
      <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" style="float: right;">
        <i class="pi pi-pencil" (click)="showEditPaymentTerm(term)"></i></span>
        <!-- Net -->
      <p *ngIf="term.type && term.type.name==termConstants[0] && term.netDueDay">Net due in {{term.netDueDay}} days</p>
      <p *ngIf="term.type &&  term.type.name==termConstants[0] && term.discount && term.discountBefore">Discount percentage is {{term.discount}} %, Discount if paid within {{term.discountBefore}} days</p>
        <!-- Date Driven -->
      <p *ngIf="term.type &&  term.type.name==termConstants[1] && term.netDueDay && term.nextMonthBeforeDue">Net due before the {{term.netDueDay}}th day of the month, Due the next month if issued within {{term.nextMonthBeforeDue}} days of the due date</p>
      <p *ngIf="term.type &&  term.type.name==termConstants[1] && term.discount && term.discountBefore">Discount percentage is {{term.discount}} % , Discount if paid before {{term.discountBefore}}th day of the month</p>
    </p-fieldset>
  </ng-container>


  <p-dialog header="{{addEditPaymentTermHeader}}" [(visible)]="display" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}" (onHide)="hideDialog()">
  <form [formGroup]="paymentTermForm">
    <div class="header">
      <h5>Payment Term Information
        <p-inputSwitch class="header-switch" formControlName="statusId" (onChange)="checkPaymentTermStatus()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
          <label>Name <span style="color: red;">*</span></label>
          <input pInputText type="text" id="name" name="name" formControlName="name" />
          <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
          <label>Type</label>
          <p-dropdown [options]="allTermTypes" formControlName="typeId" optionLabel="name"
             placeholder="Select Type" [disabled]="!isAddPaymentTerm" (onChange)="resetFields()" [ngModelOptions]="{standalone: true}" 
            appendTo="body" >
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid" *ngIf="paymentTermForm.controls['typeId'].value && paymentTermForm.controls['typeId'].value.name==termConstants[0]">
        <div class="p-col-12">
          <label>
            Net due in 
            <input pInputText type="text" id="netDay" name="netDay" class="small" formControlName="netDueDay" />
            days
          </label>
        </div>
        <div class="p-col-12">
          <label>
            Discount percentage is
            <input pInputText type="text" id="discount2" name="discount2" class="small" 
            formControlName="discount"/> % ,
            Discount if paid within 
            <input pInputText type="text" id="discountDay" name="discountDay" class="small" 
            formControlName="discountBefore" />
            days
          </label>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid" *ngIf="paymentTermForm.controls['typeId'].value && paymentTermForm.controls['typeId'].value.name==termConstants[1]">
        <div class="p-col-12">
          <label>
            Net due before the 
            <input pInputText type="text" id="netDue" name="netDue" class="small" formControlName="netDueDay" />
             th day of the month,
             Due the next month if issued within 
            <input pInputText type="text" id="nextWithin" name="nextWithin" class="small"
            formControlName="nextMonthBeforeDue"/>
            days of the due date
          </label>
        </div>
        <div class="p-col-12">
          <label>
            Discount percentage is 
            <input pInputText type="text" id="discount2" name="discount2" class="small" 
            formControlName="discount"/> % ,
            Discount if paid before 
            <input pInputText type="text" id="discountPaid" name="discountPaid" class="small" 
            formControlName="discountBefore" />
            th day of the month
          </label>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid" *ngIf="paymentTermForm.controls['typeId'].value && paymentTermForm.controls['typeId'].value.name==termConstants[2]">
        <div class="p-col-12">
          <label>Payment Term Name</label>
          <input pInputText type="text" id="otherName" name="otherName" formControlName="description" />
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="display=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!paymentTermForm.valid" (click)="savePaymentTerm(paymentTermForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>
 

      
 